import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { BACKEND_API_URL } from "../../config";



export const fetchOnboardingForm = createAsyncThunk(
  'OnboardingForm/fetch',
  async (data, {rejectWithValue}) => {
    try {
      const response = await fetch(`${BACKEND_API_URL}/api/onboarding-form-data`);
      if (!response.ok) {
        throw new Error('Failed to fetch initial state');
      }
      const initialState = await response.json();
      // console.log("Onboarding Form: ", initialState)
      return initialState;
    } catch (error) {
      console.error('Error fetching initial state:', error);
      return rejectWithValue("Error while loading the form");
    }
        
  }
)

// GET Employees List
export const fetchInitialState = createAsyncThunk(
  'EmployeeDetails/fetch', 
  async (data, { getState, dispatch, rejectWithValue }) => {
    // const currentStep = getState().navigator.currentStep;
    const token = getState().navigator.token;

    if (token) {
      try {
        const response = await fetch(`${BACKEND_API_URL}/api/onboarding/employees?token=${token}`);
        if (!response.ok) {
          return rejectWithValue('Failed to fetch initial state');
        }
        const initialState = await response.json();
        // console.log("GET employees: ", initialState);
        return initialState.data;
      } catch (error) {
        console.error('Error fetching initial state:', error);
        return []
      }
    }
    else {
      return []
    }
    
  })


  // GET Co Managers List
export const fetchInitialCoManagerState = createAsyncThunk(
  'EmployeeDetails/fetchCoManager', 
  async (data, { getState, dispatch, rejectWithValue }) => {
    // const currentStep = getState().navigator.currentStep;
    const token = getState().navigator.token;

    if (token) {
      try {
        const response = await fetch(`${BACKEND_API_URL}/api/onboarding/co_managers?token=${token}`);
        if (!response.ok) {
          return rejectWithValue('Failed to fetch initial state');
        }
        const initialState = await response.json();
        // console.log("GET employees: ", initialState);
        return initialState.data;
      } catch (error) {
        console.error('Error fetching initial state:', error);
        return []
      }
    }
    else {
      return []
    }
    
  })

// Update Employee Details
export const updateEmployeeDetails = createAsyncThunk(
    'EmployeeDetails/update', 
    async (data, { getState, dispatch }) => {
      // const currentStep = getState().navigator.currentStep;
      const token = getState().navigator.token;

      if (token) {
        try {
          const response = await fetch(`${BACKEND_API_URL}/api/onboarding/add_employee?token=${token}`, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                }
          });
          if (!response.ok) {
            throw new Error('Failed to fetch initial state');
          }
          const updated_data = await response.json();
          // console.log("Form submitted: ", updated_data);
          return updated_data.data;
        } catch (error) {
          console.error('Error fetching initial state:', error);
          return data
        }
      }
      else {
        return data
      }
      
    })


// Create New Employee
export const SubmitEmployeeDetails = createAsyncThunk(
    'EmployeeDetails/submit',
    async (data, { getState, dispatch, rejectWithValue }) => {
        try {
          // Add userId to the data
          // const currentStep = getState().navigator.currentStep;
          const token = getState().navigator.token;
          if (!token) {
            // console.log("token not found!");
            return ;
          }
          const response = await fetch(`${BACKEND_API_URL}/api/onboarding/add_employee?token=${token}`, {
              method: 'POST',
              body: JSON.stringify(data),
              headers: {
                  'Content-Type': 'application/json',
              }
          });
          const response_data =  await response.json();
          // Handle the response data
          // console.log('Form submitted successfully', response_data);
    
          // Return the response data for the fulfilled action
          // dispatch(updateUserId({ userId: response_data['id']}));
          return response_data.data;
        } catch (error) {
          // Handle submission errors
          console.error('Form submission error', error);
          // Throw an error for the rejected action
          return error;
        }
      }
)


// DELETE an Employee
export const deleteEmployeeDetails = createAsyncThunk(
  'EmployeeDetails/delete', 
  async (data, { getState, dispatch, rejectWithValue }) => {
    // console.log(data);
    // const currentStep = getState().navigator.currentStep;
    const token = getState().navigator.token;
    if (token) {
      try {
          const response = await fetch(`${BACKEND_API_URL}/api/onboarding/delete_employee?token=${token}`, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                }
          });
          if (!response.ok) {
            return rejectWithValue('Failed to delete an user');
          }
          const response_data = await response.json();
          return response_data.data;
      } catch (error) {
          console.error('Error deleting the user:', error);
          return rejectWithValue('Error deleting the user:', error);
      }
    }
    else {
      return data
    }
    
  })


// Slice
const initialState = {
  data: [],
  onboardingForm: [],  // this is form structure data recieved from Database
  // managerNames: {value: []},
  status: 'idle', // 'idle' | 'loading' | 'success' | 'failed'
  loading: false,
  error: null,
}

export const employeeDetailsSlice = createSlice({
    name: 'EmployeeDetails',
    initialState,
    reducers: {
      setFormField: (state, action) => {
        const { field, value } = action.payload;
        state.data[field] = value;
      },
      setFieldError: (state, action) => {
        const { field, error } = action.payload;
        state.formErrors[field] = error;
      },
    },
    extraReducers: (builder) => {
        builder
          // CREATE
          .addCase(SubmitEmployeeDetails.pending, (state) => {
            state.loading = true;
          })
          .addCase(SubmitEmployeeDetails.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
          })
          .addCase(SubmitEmployeeDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          })

          // GET
          .addCase(fetchInitialState.pending, (state) => {
            state.loading = true;
          })
          .addCase(fetchInitialState.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            // state.managerNames = action.payload.managerNames;
          })
          .addCase(fetchInitialState.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          })

          // GET
          .addCase(fetchInitialCoManagerState.pending, (state) => {
            state.loading = true;
          })
          .addCase(fetchInitialCoManagerState.fulfilled, (state, action) => {
            state.loading = false;
            state.co_managers = action.payload;
            // state.managerNames = action.payload.managerNames;
          })
          .addCase(fetchInitialCoManagerState.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          })

          // GET OnBoarding FORM DATA
          .addCase(fetchOnboardingForm.pending, (state) => {
            state.loading = true;
          })
          .addCase(fetchOnboardingForm.fulfilled, (state, action) => {
            state.loading = false;
            state.onboardingForm = action.payload;
          })
          .addCase(fetchOnboardingForm.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          })

          // UPDATE
          .addCase(updateEmployeeDetails.pending, (state) => {
            state.loading = true;
          })
          .addCase(updateEmployeeDetails.fulfilled, (state, action) => {
            state.loading = false;
            // let index = state.data.findIndex(obj => obj.id === action.payload.id);
            // // Replace the object if it exists
            // if (index !== -1) {
            //     state.data[index] = action.payload;
            // }
            state.data = action.payload;
          })
          .addCase(updateEmployeeDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          })

          // DELETE
          .addCase(deleteEmployeeDetails.pending, (state) => {
            state.loading = true;
          })
          .addCase(deleteEmployeeDetails.fulfilled, (state, action) => {
            state.loading = false;
            // let index = state.data.findIndex(obj => obj.id === action.payload.id);
            // // Delete the object if it exists
            // if (index !== -1) {
            //     state.data.splice(index, 1);
            // }
            state.data = action.payload;
          })
          .addCase(deleteEmployeeDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          })
      },
  });


export const { setFormField, setFieldError } = employeeDetailsSlice.actions;

export default employeeDetailsSlice.reducer;
  